import React, { useState } from 'react';
import { Col, Row, Button, Space, Spin, message } from 'antd';
import { useHistory } from 'react-router-dom';

import { CollapseCustom } from './Collapse';
import { putFinalizarAtendimentoExterno } from '../../../services';

import * as S from '../styles';

export function ConsultasExternas({ data }) {
  const history = useHistory();
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [consultas, setConsultas] = useState([]);

  const handlerfinalizarAtendimento = async () => {
    setLoadingBtn(true);
    setDisabledBtn(true);

    const response = await putFinalizarAtendimentoExterno({
      consultas,
    });

    response?.status === 200
      ? message.success('Atendimento finalizado com sucesso.')
      : message.error(
          response?.error?.response?.data?.detail ||
            'Erro ao finalizar atendimento.'
        );

    const isRedirect = response?.status === 200;

    setLoadingBtn(false);
    setDisabledBtn(false);

    return isRedirect && redirect();
  };

  const redirect = () =>
    history.push('/atendimento-finalizado', { origem: 'externa' });

  return (
    <Col
      style={{
        padding: '16px 28px 0 0',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Col>
        {data?.length > 0 && (
          <S.ContentConsultas>
            <Col>
              <CollapseCustom
                data={data}
                btnDisabled={setDisabledBtn}
                dataAtendimento={setConsultas}
              />
              <Row justify="center">
                <Button
                  onClick={handlerfinalizarAtendimento}
                  type="primary"
                  disabled={disabledBtn}
                  style={{
                    width: 161,
                    height: 56,
                    background: disabledBtn ? '#BDBDBD' : '#24a95d',
                    border: 'none',
                    fontWeight: 'bold',
                    fontSize: 16,
                    marginTop: 40,
                    marginBottom: 20,
                  }}
                >
                  <Space>
                    {loadingBtn ? (
                      <Spin
                        spinning={loadingBtn}
                        size="small"
                        style={{
                          color: '#24A95D',
                        }}
                      />
                    ) : (
                      <Space>FINALIZAR</Space>
                    )}
                  </Space>
                </Button>
              </Row>
            </Col>
          </S.ContentConsultas>
        )}
      </Col>
    </Col>
  );
}
